import { Link } from "gatsby"
import React from "react"
import { Button } from "./layout/Button"
import { LazyLoadImage } from "react-lazy-load-image-component"

export const ShopLook: React.FC<{
  img: {
    src: string
    alt: string
  }
  to: string
}> = props => {
  return (
    <div className="flex flex-col w-full">
      <Link to={props.to} className="mb-5 flex-1 w-full relative" style={{
        paddingTop: "125%"
      }}>
        <LazyLoadImage
          src={`${props.img.src}&width=800`}
          alt={props.img.alt}
          className="object-cover w-full h-full absolute top-0 bg-white"
        />

      </Link>

      <Button xtraStyles="text-center py-2 hidden md:block" href={props.to}>
        SHOP THIS LOOK
      </Button>
    </div>
  )
}
